/** Chiamate all'API di autenticazione. Nessun URL hardcodato altrove. */

import { api, apiRequest } from '@/lib/api-client';

export type User = {
  id: string;
  email: string;
  displayName: string | null;
  baseCurrency: string;
  /** Abilita le azioni riservate (es. resoconto di mercato su richiesta). */
  isPremium: boolean;
  /**
   * Privilegio di amministrazione, derivato lato server da `ADMIN_EMAILS`.
   * Governa **solo** la visibilità della voce di menu e della rotta: chi lo
   * forzasse a `true` nel proprio client vedrebbe una pagina che non riesce a
   * caricare nulla, perché ogni richiesta è comunque verificata dal backend.
   */
  isAdmin: boolean;
  createdAt: string;
  lastLoginAt: string | null;
};

export type AuthResponse = {
  user: User;
  accessToken: string;
  expiresIn: number;
};

export type LoginPayload = {
  email: string;
  password: string;
};

export type RegisterPayload = LoginPayload & {
  displayName?: string;
  baseCurrency?: string;
};

// `skipAuthRetry`: su questi endpoint un 401 è la risposta legittima
// ("credenziali errate"), non un token scaduto da rinnovare.
export const login = (payload: LoginPayload) =>
  api.post<AuthResponse>('/auth/login', payload, { skipAuthRetry: true });

export const register = (payload: RegisterPayload) =>
  api.post<AuthResponse>('/auth/register', payload, { skipAuthRetry: true });

export const logout = () => apiRequest<void>('/auth/logout', { method: 'POST', skipAuthRetry: true });

export const fetchMe = () => api.get<User>('/auth/me');
